/**
 * Public landing page — the marketing front door for Pet Marketplace.
 * Playful claymorphism (matches the consoles' design system) with a
 * "Book a demo" primary CTA, and clear paths into both the Pet-Owner
 * (/user/login) and Vendor (/login) consoles.
 *
 * Composition only — each section owns its own markup + state.
 */
import { LandingNav } from './landing-nav';
import { LandingHero } from './landing-hero';
import { LandingCategories } from './landing-categories';
import { LandingHowItWorks } from './landing-how-it-works';
import { LandingAudience } from './landing-audience';
import { LandingSocialProof } from './landing-social-proof';
import { LandingFooter } from './landing-footer';

export function LandingPage() {
  return (
    <div className="min-h-svh bg-background">
      <LandingNav />
      <main>
        <LandingHero />
        <LandingCategories />
        <LandingHowItWorks />
        <LandingAudience />
        <LandingSocialProof />
      </main>
      <LandingFooter />
    </div>
  );
}
